// src/components/layout/DesktopShell.tsx
import React from "react";
import Header from "./Header";
import SidebarExpanded from "./SidebarExpanded";
import SidebarCollapsed from "./SidebarCollapsed";

type Props = {
  hideSidebar: boolean;
  sidebarOpen: boolean;
  onToggleSidebar: () => void;
  children: React.ReactNode;
};

const DesktopShell: React.FC<Props> = ({
  hideSidebar,
  sidebarOpen,
  onToggleSidebar,
  children,
}) => {
  return (
    <>
      <Header />
      <div className="flex h-screen pt-14">
        {!hideSidebar &&
          (sidebarOpen ? (
            <SidebarExpanded onToggle={onToggleSidebar} />
          ) : (
            <SidebarCollapsed onToggle={onToggleSidebar} />
          ))}

        <main
          className={`flex-1 overflow-auto transition-all duration-300 ${
            hideSidebar ? "" : sidebarOpen ? "ml-60" : "ml-14"
          }`}
        >
          {children}
        </main>
      </div>
    </>
  );
};

export default DesktopShell;